import React from "react";
import { connect } from "react-redux";
import { Row, Col, Skeleton, Divider } from "antd";

import AtarEligibilityInfo from "components/atar/AtarEligibilityInfo";
import AddMoreSubjects from "components/atar/AddMoreSubjects";
import MostRelevantSubjects from "components/atar/MostRelevantSubjects";
import OtherRelevantSubjects from "./OtherRelevantSubjects";
import ProfileSummary from "components/atar/ProfileSummary";
import ApiErrorHandling from "components/atar/ApiErrorHandling";

import { ACTION_TYPE } from "reducers/actionType";
import {
  MOST_RELEVANT_SUBJECTS,
  makeSubjectErrorOb,
  makeFailureMessages,
  renderFailureMessages
} from "utils/helpers";
import SummaryFooter from "components/footers/SummaryFooter";
import UserPrompt from "./UserPrompt";
import "styles/Summary.scss";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";

class Summary extends React.Component {
  state = {
    focus: false
  };
  componentDidMount = () => {
    const {
      recommendedSubjects,
      otherSubjects,
      additionalSubjects
    } = this.props;
    if (
      recommendedSubjects.length <= 0 &&
      otherSubjects.length <= 0 &&
      additionalSubjects.length <= 0
    ) {
      const { subjects } = this.props.input;
      const newAdditionalSubjects = Object.keys(subjects);
      this.props.dispatch({
        type: ACTION_TYPE.additionalSubjects,
        data: { additionalSubjects: newAdditionalSubjects }
      });
    }
  };

  clearSubjects = () => {
    this.props.dispatch({
      type: ACTION_TYPE.pickRecSubs,
      data: { userRecSubs: [] }
    });
    this.props.dispatch({
      type: ACTION_TYPE.pickOthSubs,
      data: { userOthSubs: [] }
    });
    this.props.dispatch({
      type: ACTION_TYPE.pickAddSubs,
      data: { userAddSubs: [] }
    });
  };

  handleFocusSelect = () => {
    if (navigator.userAgent.match(/Android/i)) {
      this.setState({ focus: true });
      document
        .getElementById("Select Subjects Label")
        .scrollIntoView({ behaviour: "smooth" });
    }
  };
  handleBlurSelect = () => {
    if (navigator.userAgent.match(/Android/i)) {
      this.setState({ focus: false });
    }
  };

  renderClearButton = () => (
    <div className="padding-sides margin-top margin-bottom">
      <div className="clear-button-container">
        <MasterButton
          type={BUTTON_TYPES.CLEAR}
          text="Clear All Selected Subjects"
          className="clear-selection no-margin"
          callback={this.clearSubjects}
        />
      </div>
    </div>
  );

  renderRecommendations = () => {
    const {
      recommendations,
      error,
      loading,
      eligibility,
      recommendations_input_hash
    } = this.props;
    let subjectErrorOb = {};
    if (eligibility) {
      subjectErrorOb = makeSubjectErrorOb(eligibility);
    }

    if (error) {
      return <ApiErrorHandling error={error} />;
    } else if (loading) {
      return <Skeleton active className="padding-sides" />;
    } else if (recommendations.length === 0 && recommendations_input_hash) {
      return <UserPrompt />;
    } else if (recommendations.length === 0) {
    } else {
      return (
        <div>
          <MostRelevantSubjects
            recommendations={recommendations}
            subjectErrorOb={subjectErrorOb}
          />
          {recommendations.length > MOST_RELEVANT_SUBJECTS && (
            <OtherRelevantSubjects
              recommendations={recommendations}
              subjectErrorOb={subjectErrorOb}
            />
          )}
        </div>
      );
    }
  };

  renderSidebar = () => {
    const { recommendations, eligibility, loading } = this.props;

    // recommendations and eligibility both exist
    let failureMessages = [];
    if (eligibility) {
      failureMessages = makeFailureMessages(eligibility);
    }
    return (
      <div className="summary-padding-left">
        {recommendations && recommendations.length > 0 ? (
          <div>
            <h1>HSC subject suggestions</h1>
            <div className="margin-bottom">
              The subjects displayed are those that best match your profile. Now
              it's time to make your final selection.{" "}
              <div className="inline-bold">
                Remember that you need to complete at least 12 units in Year 11.
              </div>
            </div>
          </div>
        ) : (
          <h1>Select your subjects</h1>
        )}
        <AtarEligibilityInfo />
        {!loading && eligibility && (
          <div>
            <Divider className="desktop-only" />
            {renderFailureMessages(failureMessages)}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { userRecSubs, userOthSubs, userAddSubs } = this.props;

    const subjectsSelected =
      userRecSubs.length > 0 ||
      userAddSubs.length > 0 ||
      userOthSubs.length > 0;

    return (
      <div>
        <Row className="summary">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            {this.renderSidebar()}
          </Col>

          <Col
            xs={24}
            sm={24}
            md={16}
            lg={16}
            xl={16}
            className="vertical-border-left padding-top"
          >
            {this.renderRecommendations()}
            <AddMoreSubjects
              handleFocusSelect={this.handleFocusSelect}
              handleBlurSelect={this.handleBlurSelect}
            />
            {subjectsSelected && this.renderClearButton()}
            <ProfileSummary />
          </Col>
        </Row>
        <SummaryFooter
          focus={this.state.focus}
          enable={subjectsSelected}
          nextNavlink="summary/atar-eligible"
        />
      </div>
    );
  }
}

const mapStateToProps = store => {
  const { recommendations, error, loading } = store.recommendationsReducer;
  const { eligibility } = store.eligibilityReducer;

  const { userRecSubs } = store.pickRecSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;
  const { recommendedSubjects } = store.recommendedSubjectsReducer;
  const { otherSubjects } = store.otherSubjectsReducer;
  const { additionalSubjects } = store.additionalSubjectsReducer;

  const { input } = store.inputReducer;
  const {
    recommendations_input_hash,
    eligibility_input_hash
  } = store.hashReducer;
  return {
    recommendations: recommendations,

    loading: loading,
    error: error,
    input: input,
    userRecSubs: userRecSubs,
    userOthSubs: userOthSubs,
    userAddSubs: userAddSubs,

    recommendedSubjects: recommendedSubjects,
    otherSubjects: otherSubjects,
    additionalSubjects: additionalSubjects,
    eligibility: eligibility,

    recommendations_input_hash: recommendations_input_hash,
    eligibility_input_hash: eligibility_input_hash
  };
};

export default connect(mapStateToProps)(Summary);
